import React, { useEffect, useRef } from 'react'
import '../styles/Services.css'
import { T } from './Translation'
import sendSMSImage from '../assets/sendSMS.png'
import aiImage from '../assets/ai.png'
import presentImage from '../assets/present.png'
import locationImage from '../assets/loaction.png'
import monitorGuestListImage from '../assets/monitorGuestList.png'
// import detailsImage from '../assets/details.png'
import transportImage from '../assets/transport.png' // Assuming you have a transport image

function Services() {
  const servicesRef = useRef(null)

  useEffect(() => {
    // This effect handles direct navigation to #services from URL
    if (window.location.hash === '#services' && servicesRef.current) {
      servicesRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  return (
    <section id="services" ref={servicesRef} className="services-section">
      <h2>
        <T k="servicesHeader" />
      </h2>
      <div className="services-cards">
        <div className="service-card">
          <div className="service-image">
            <img src={sendSMSImage} alt="Send SMS" />
          </div>
          <h3>
            <T k="service1Title" />
          </h3>
          <p>
            <T k="service1Desc" />
          </p>
        </div>
        <div className="service-card">
          <div className="service-image">
            <img src={aiImage} alt="AI Assistant" />
          </div>
          <h3>
            <T k="service2Title" />
          </h3>
          <p>
            <T k="service2Desc" />
          </p>
        </div>
        <div className="service-card">
          <div className="service-image">
            <img src={locationImage} alt="See Location" />
          </div>
          <h3>
            <T k="service4Title" />
          </h3>
          <p>
            <T k="service4Desc" />
          </p>
        </div>
        <div className="service-card">
          <div className="service-image">
            <img src={monitorGuestListImage} alt="Monitor Guest List" />
          </div>
          <h3>
            <T k="service5Title" />
          </h3>
          <p>
            <T k="service5Desc" />
          </p>
        </div>
        <div className="service-card">
          <div className="service-image">
            <img src={transportImage} alt="Event Details" />
          </div>
          <h3>
            <T k="service6Title" />
          </h3>
          <p>
            <T k="service6Desc" />
          </p>
        </div>
        <div className="service-card coming-soon-card">
          <div className="coming-soon-ribbon">
            <T k="comingSoon" />
          </div>
          <div className="service-image">
            <img src={presentImage} alt="Send Present" />
          </div>
          <h3>
            <T k="service3Title" />
          </h3>
          <p>
            <T k="service3Desc" />
          </p>
        </div>
      </div>
    </section>
  )
}

export default Services
